import { checkIsPickUp } from "shared/utility/types";

export const tripKindLabelKey = (kind) => `driverPerformance.kind.${kind}`;

export const tripKindLabel = (kind, t) => {
  if (!kind) return "";
  return t(tripKindLabelKey(kind), { defaultValue: kind });
};

export const routeTypeLabel = (routeType, t) => {
  if (!routeType) return null;
  return checkIsPickUp(routeType) ? t("pickUp") : t("dropOff");
};

export const buildTripTooltipLines = (trip, t) => {
  if (!trip) return [];

  const lines = [trip.name || trip.serviceId, `${trip.startTime} → ${trip.endTime}`];

  const routeLabel = routeTypeLabel(trip.routeType, t);
  if (routeLabel) lines.push(routeLabel);

  if (trip.kind) {
    lines.push(tripKindLabel(trip.kind, t));
  }

  if (typeof trip.assignment?.cost === "number") {
    lines.push(`${t("driverScheduler.optimizationCost")}: ${trip.assignment.cost.toFixed(2)}`);
  }

  return lines;
};
